import { useEffect, useState } from "react";
import { NON_DASHBOARD_PAGES, SIDEBAR_ITEMS } from "enums";
import { Link, useLocation } from "react-router-dom";
import ProfileDropdown from "components/profile-dropdown";
import { ReactComponent as CloseIcon } from "assets/svgs/close-modal.svg";
import { ReactComponent as ToggleIcon } from "assets/svgs/menu-toggle.svg";

const MobileHeader = () => {
   const location = useLocation();
   const hideProfile = NON_DASHBOARD_PAGES.includes(location.pathname);

   const [showSidebar, setShowSidebar] = useState(false);

   const justifyClass = hideProfile ? "justify-center" : "justify-between";
   const activeClass = "bg-white border-l-4 border-solid border-[#243b68]";

   useEffect(() => {
      if (showSidebar) {
         document.body.style.overflowY = "hidden";
      } else {
         document.body.style.overflowY = "auto";
      }
   }, [showSidebar]);

   // Close sidebar when navigating to a new page
   useEffect(() => {
      setShowSidebar(false);
   }, [location.pathname]);

   return (
      <>
         {/* Mobile Header Bar */}
         <div
            className={`py-3 px-4 fixed top-0 left-0 w-full bg-white shadow-sm flex items-center ${justifyClass} lg:hidden z-40`}
         >
            <div className="flex items-center gap-2">
               {!hideProfile && (
                  <button
                     type="button"
                     onClick={() => setShowSidebar(true)}
                     className="bg-primary rounded-md p-2 hover:opacity-90 transition-opacity"
                     aria-label="Open menu"
                  >
                     <ToggleIcon />
                  </button>
               )}

               <Link to="/">
                  <img
                     alt="logo"
                     src={`/logo-name.png`}
                     className="h-8 w-auto"
                  />
               </Link>
            </div>

            
         </div>

         {/* Spacer for fixed header */}
         <div className="h-14 lg:hidden" />

         {/* Mobile Sidebar Drawer */}
         {!hideProfile && (
            <>
               {/* Backdrop/Overlay */}
               {showSidebar && (
                  <div
                     className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
                     onClick={() => setShowSidebar(false)}
                     aria-hidden="true"
                  />
               )}

               {/* Sidebar */}
               <div
                  style={{
                     transform: !showSidebar ? "translateX(-100%)" : "translateX(0%)",
                  }}
                  className="fixed bg-primary z-50 top-0 left-0 h-full w-[280px] transition-transform duration-300 ease-in-out flex flex-col shadow-xl"
               >
                  {/* Header */}
                  <div className="flex justify-between items-center px-4 py-4 flex-shrink-0 border-b border-grey2/30">
                     <Link to="/" onClick={() => setShowSidebar(false)}>
                        <img
                           alt="logo"
                           src={`/logo-name.png`}
                           className="h-8 w-auto"
                        />
                     </Link>
                     <button
                        onClick={() => setShowSidebar(false)}
                        className="p-1 hover:opacity-80 transition-opacity"
                        aria-label="Close menu"
                     >
                        <CloseIcon />
                     </button>
                  </div>

                  {/* Navigation */}
                  <div className="flex-1 overflow-y-auto scrollbar-thin">
                     <nav className="py-2">
                        <ul className="space-y-0.5">
                           {SIDEBAR_ITEMS(true).map((item) => (
                              <li key={item.to}>
                                 <Link
                                    to={item.to}
                                    onClick={() => setShowSidebar(false)}
                                    className={`flex items-center gap-3 py-3 pl-6 pr-4 transition-all hover:bg-white/90 ${
                                       location.pathname === item.to
                                          ? activeClass
                                          : "border-l-4 border-solid border-transparent"
                                    }`}
                                 >
                                    <span className="flex-shrink-0">
                                       {item.icon}
                                    </span>
                                    <span className="text-base font-medium">
                                       {item.label}
                                    </span>
                                 </Link>
                              </li>
                           ))}
                        </ul>
                     </nav>
                  </div>

                  {/* Bottom Section */}
                  <div className="flex-shrink-0 border-t border-grey2/30">
                     {/* Profile Dropdown */}
                     <div className="px-4 py-3">
                        <ProfileDropdown />
                     </div>
                  </div>
               </div>
            </>
         )}
      </>
   );
};

export default MobileHeader;